import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { PermissionService } from '../../auth/services/permissions.service';
import { DefaultRouteConfig, getDefaultRedirectPath } from '@core/utils';

/**
 * Default redirect guard for unauthorized users.
 * Redirects to the first accessible route based on the provided configuration.
 * @param route
 * @param state
 */
export const defaultRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const defaultRoutes: DefaultRouteConfig[] = route.data['defaultRoutes'] || [];
  const fallback: string = route.data['fallback'] || '/unauthorized';

  const redirectPath = getDefaultRedirectPath(defaultRoutes, fallback, permissionService);

  return router.createUrlTree(['/messages', redirectPath]);
};
